import React from 'react';

export function AboutViewer() {
  const data = require('../../../assets/lang/components/about.json');

  return (
    <section className="about">
      <div className="about__inner">
        <div className="about__hero">
          <p className="about__eyebrow">{data.hero.eyebrow}</p>
          <h1>{data.hero.title}</h1>
          <p className="about__lede">{data.hero.lede}</p>
        </div>

        <div className="about__panel about__panel--story">
          <h2>{data.story.title}</h2>
          {data.story.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <div className="about__panel">
          <div className="about__section-heading">
            <p className="about__eyebrow">{data.founders_section.eyebrow}</p>
            <h2>{data.founders_section.title}</h2>
          </div>

          <div className="about__founder-grid">
            {data.founders.map((founder) => (
              <article className="about__founder-card" key={founder.name}>
                <div className="about__founder-avatar" aria-hidden="true">
                  {founder.name.charAt(0)}
                </div>
                <h3>{founder.name}</h3>
                <p className="about__founder-role">{founder.role}</p>
                <p>{founder.bio}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
